import { OutreachContent } from "@/api/generated/models";
import { AssistantClientEvent } from "@/api/model/Conversation";
import OutreachNote from "@/components/OutreachNote";
import MessageSatisfaction from "../MessageSatisfaction";

export interface OutreachMessageProps extends AssistantClientEvent {
  content: OutreachContent;
  type: "outreach";
}

const OutreachMessage = ({
  content,
  messageId,
  maybeCopy,
  feedback,
  feedbackComment,
}: OutreachMessageProps) => {
  return (
    <>
      <OutreachNote title={content.title} message={content.message} />
      <MessageSatisfaction
        messageId={messageId}
        feedback={feedback}
        feedbackComment={feedbackComment}
        onCopy={() => maybeCopy(content.message)}
      />
    </>
  );
};

export default OutreachMessage;
